import { Box, Button, Text, Select } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetScheduleData,
  selectedMenu,
  setHeaderText,
} from '../../redux/actions/actions';
import 'flatpickr/dist/themes/material_green.css';
import Flatpickr from 'react-flatpickr';
import {
  getCategories,
  getClasses,
  loadSchedule,
  getDegree,
} from '../../redux/api_calls/apiCalls';
import ManageScheduleRow from './ManageScheduleRow';

export default function ManageSchedule() {
  const slider = useSelector((state) => state.sliderState.sliderOpen);
  const headerText = useSelector((state) => state.headerState.headerText);
  const { scheduleData, isLoading } = useSelector(
    (state) => state.scheduleState
  );
  const classesData = useSelector((state) => state.classesState.classesData);
  const [selectedClassValue, setSelectedClassValue] = useState('0');
  const classRef = useRef();
   const specificationRef = useRef();
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [finalData, setFinalData] = useState(null);
  const [headers, setHeaders] = useState([]);
  const [timings, setTimings] = useState([]);
  const [scheduleDegrees, setScheduleDegrees] = useState([]);
  const [schedulepecification, setScheduleSpecification] = useState([]);
  const [selectedScheduleDegreeValue, setSelectedScheduleDegreeValue] = useState('0');
  const [selectedScheduleSpecificationValue, setSelectedScheduleSpecificationValue] = useState('0');
  
  useEffect(() => {
     const loadFieldData2 = async () => {
      let degree = await getDegree();
       let data = degree.data;
       setScheduleDegrees(data);
     };
     loadFieldData2();
  }, [setScheduleDegrees]);



  const getScheduleHandler = () => {
  if (selectedScheduleDegreeValue === '0') {
      alert('Please select a degree!');
      return;
    }
    if (selectedClassValue === '0') {
      alert('Please select a class!');
      return;
    }
    if (startDate === '') {
      alert('Please select start date!');
      return;
    }
    if (endDate === '') {
      alert('Please select end date!');
      return;
    }
    let weekCheck =
      Date.parse(endDate.split('-').reverse().join('-')) -
        Date.parse(startDate.split('-').reverse().join('-')) >=
      604800000;

    if (weekCheck) {
      alert('Please select a duration less than or equal to 7 days');
      return;
    }
    localStorage.setItem('startDate',startDate.split('-').reverse().join('-'));
    localStorage.setItem('endDate',endDate.split('-').reverse().join('-'));
    localStorage.setItem('class',selectedClassValue);

    dispatch(
      loadSchedule(
        startDate.split('-').reverse().join('-'),
        endDate.split('-').reverse().join('-'),
        selectedClassValue === '0' ? '1' : selectedClassValue,
        selectedScheduleDegreeValue === '0' ? '1' : selectedScheduleDegreeValue,
        selectedScheduleSpecificationValue === '0' ? '1' : selectedScheduleSpecificationValue
      )
    );
  };

  const classChangeHandler = () => {
    setSelectedClassValue(classRef.current.value);
  };

 

  useEffect(() => {
    if (scheduleData) {
      let entries = Object.entries(scheduleData);
      if (entries.length) {
        let columns = entries.length;
        let rows = Object.entries(entries[0][1]).length;
        let displayData = new Array(rows)
          .fill(0)
          .map((row) => new Array(columns).fill(0).map((col) => null));
        let col = 0;
        for (let dates in scheduleData) {
          for (let i = 0; i < 6; i++) {
            if (scheduleData[dates][`Session${i + 1}`]) {
              displayData[i][col] = scheduleData[dates][`Session${i + 1}`];
            }
          }
          col++;
        }
        console.log('displya', displayData);
        setFinalData(displayData);
        let days = [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ];
        let getDay = (date) => days[new Date(date).getDay()];
        let headerData = entries.map((date) => [
          date[0].split('-').reverse().join('-'),
          getDay(date[0]),
        ]);
        setHeaders(headerData);

        let timingsData = [
          '09:30 - 10:30',
          '11:00 - 12:00',
          '12:00 - 01:00',
          '02:00 - 03:00',
          '04:00 - 05:00',
          '05:00 - 06:00',
        ];
        setTimings(timingsData.slice(0, rows));
      } else {
        setFinalData([]);
      }
    }
  }, [scheduleData]);

  useEffect(() => {
    dispatch(setHeaderText('Manage Classes'));
    dispatch(getClasses());
    dispatch(getCategories());
    //getDefaultSchedule();
    dispatch(selectedMenu(5));
    return () => dispatch(resetScheduleData());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(resetScheduleData());
    // eslint-disable-next-line
  }, [startDate, endDate]);

  const specificationChangeHandler = () => {
    setSelectedScheduleSpecificationValue(specificationRef.current.value);
  };
  const handleScheduleSpecificationChange = (event) => {
  setSelectedScheduleDegreeValue(event);
    const token = JSON.parse(window.localStorage.getItem('user')).access_token;
    fetch(
      'https://simplifyed.io/dev-api/class/api/tutor/getSpecifications/' + event,
      {
        headers: { Authorization: 'Bearer ' + token },
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        setScheduleSpecification(items.payload.data);
      });
  };
  return (
    <Box
      d='flex'
      justifyContent='flex-start'
      alignItems='center'
      flexDirection='column'
      minH='90vh'
      pl={[
        '0',
        '0',
        '0',
        slider ? (window.innerWidth < 1400 ? '18vw' : '13vw') : '7.5vw',
      ]}
      transition='all 350ms ease'
    >
      <Box
        width={['95%', '95%', '95%', '80%']}
        justifyContent='space-between'
        alignItems='center'
        d='flex'
        mb='2rem'
      >
        <Text
          fontSize={['20px', '25px', '30px', '40px']}
          d={['none', 'none', 'none', 'flex']}
          fontWeight='900'
          style={{ fontFamily: 'Mulish, sans-serif' }}
        >
          {headerText}
        </Text>
      </Box>

      <Box width={['95%', '95%', '95%', '80%']} bg='white' borderRadius='20px'  
                    pl='1rem' mt='1rem' pr='1rem' boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)' mb='1rem'>
               <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px',textTransform:"uppercase"  }}
                                
                            >

                <Box width='33%'>
                 <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Degree
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                    onChange={(e) => handleScheduleSpecificationChange(e.target.value)}
                    fontSize='18px'
                  >
                    <option value='' key='-1'>
                      Select Degree
                    </option>
                    {scheduleDegrees === null ? (
                      <option></option>
                    ) : (
                      scheduleDegrees.map((degreesName, idx) => (
                        <option value={degreesName.id} key={idx}>
                          {degreesName.name}
                        </option>
                      ))
                    )}
                  </Select>
                </Box>

                <Box width='35%'>
                 <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Specialization
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                     fontSize='18px'
                     ref={specificationRef}
                    value={selectedScheduleSpecificationValue}
                    onChange={specificationChangeHandler}
                  >
                    <option value='' key='-1'>
                      Select Specialization
                    </option>
                    {schedulepecification === undefined ? (
                      <option></option>
                    ) : (
                      schedulepecification.map((specificationName, idx) => (
                        <option value={specificationName.id} key={idx}>
                          {specificationName.name}
                        </option>
                      ))
                    )}
                  </Select>
                </Box>
                <Box width='20%'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Class
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '95%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                    ref={classRef}
                    value={selectedClassValue}
                    onChange={classChangeHandler}
                    fontSize='18px'
                  >
                    <option value='0' key='-1'>
                      Select a Class
                    </option>
                    {classesData.map((className, idx) => (
                      <option value={className.id} key={idx}>
                        {className.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                </Box>
                <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px',textTransform:"uppercase"  }}
                                
                            >
                <Box width='25%' mr='1rem'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Start Date
                  </Text>

                  <Flatpickr
                    value={startDate}
                    options={{ dateFormat: 'd-m-Y' }}
                    placeholder='dd-mm-yyyy'
                   
                    onClick={(date, dateStr, instance) => {
                      setStartDate(dateStr);
                    }}
                    onChange={(date, dateStr, instance) => {
                      setStartDate(dateStr);
                    }}
                    style={{
                      padding: '1rem',
                      color: '#666666',
                      width: '100%',
                      height: '40px',
                      backgroundColor: 'transparent',
                      borderRadius: '13px',
                      border: '1px solid rgba(0, 0, 0, 0.1)',
                    }}
                  />
                </Box>

                <Box width='25%' mr='1rem'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select End Date
                  </Text>

                  <Flatpickr
                    value={endDate}
                    options={{ dateFormat: 'd-m-Y' }}
                    placeholder='dd-mm-yyyy'
                   onChange={(date, dateStr, instance) => {
                      setEndDate(dateStr);
                    }}
                    onClick={(date, dateStr, instance) => {
                      setEndDate(dateStr);
                    }}
                    style={{
                      padding: '1rem',
                      color: '#666666',
                      width: '100%',
                      height: '40px',
                      backgroundColor: 'transparent',
                      borderRadius: '13px',
                      border: '1px solid rgba(0, 0, 0, 0.1)',
                    }}
                  />
                </Box>

                <Box
                  height='100%'
                  d='flex'
                  justifyContent='center'
                  alignItems='flex-end'
                >
                  <Button
                    fontSize='16px'
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    colorScheme='messenger'
                    isLoading={isLoading}
                    loadingText='Fetching...'
                    onClick={getScheduleHandler}
                  >
                    Get Schedule
                  </Button>
                </Box>
              </Box>
              </Box>

      <Box
        width={['95%', '95%', '95%', '80%']}
        justifyContent='flex-start'
        alignItems='center'
        flexDir='column'
        d='flex'
        mb='2rem'
        boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
        borderRadius='20px'
      >
        {finalData && finalData.length > 0 ? (
          <Box
            w='100%'
            justifyContent='space-between'
            alignItems='center'
            d='flex'
            flexDir='column'
            bg="white"
            borderRadius='20px'
          >
            {headers.length > 0 && (
              <Box
                width='100%'
                display='flex'
                justifyContent='space-between'
                alignItems='center'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                borderBottom='1px solid rgba(0, 0, 0, 0.1)'
              >
                <Box
                  flex='1'
                  height='100px'
                  key='-1'
                  display='flex'
                  flexDir='column'
                  justifyContent='center'
                  alignItems='center'
                  color='blue'
                >
                  <Text
                    fontStyle='normal'
                    lineHeight='18px'
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    style={{ fontFamily: 'Mulish, sans-serif'  }}
                  >
                    <b>Timings</b>
                  </Text>
                </Box>
                {headers.map((day, idx) => (
                  <Box
                    flex='1'
                    height='100px'
                    key={idx}
                    display='flex'
                    flexDir='column'
                    justifyContent='center'
                    alignItems='center'
                    color='blue'
                    borderLeft='1px solid rgba(0, 0, 0, 0.1)'
                  >
                    <Text
                      fontStyle='normal'
                      lineHeight='18px'
                      fontSize='16px'
                      fontWeight='700'
                      color='#999999'
                      style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                      <b>{day[1]}</b>
                    </Text>
                    <Text
                      fontStyle='normal'
                      lineHeight='18px'
                      fontSize='16px'
                      fontWeight='700'
                      color='#999999'
                      style={{ fontFamily: 'Mulish, sans-serif'  }}
                                >
                      {day[0]}
                    </Text>
                  </Box>
                ))}
              </Box>
            )}

            {finalData &&
              finalData.map((session, idx) => (
                <ManageScheduleRow
                  key={idx}
                  id={idx + 1}
                  session={session}
                  time={timings[idx]}
                />
              ))}
          </Box>
        ) : (
          <Box
            w='100%'
            justifyContent='space-between'
            alignItems='center'
            d='flex'
            flexDir='column'
          >
            <Text>No Schedule Available for selected Class/Date-Range</Text>
          </Box>
        )}
      </Box>
    </Box>
  );
}
